export interface ProjectTypeClass {
    AccountProjectTypeId:number
    ProjectType:string
    AccountId: number
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    IsDeleted: boolean
    IsDisabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    isSelected:number
}


const common = {    
    ProjectType:"",
    IsDisabled:false
  };
  
  export const ProjectTypeInitialsForAdd = { ...common };
  
  export const ProjectTypeInitialsForUpdate = {
    ...common,
    AccountProjectTypeId: 0
  };
  

// export const ProjectTypeInitialsForApp={
//     ProjectType:"",
//     IsDisabled:false
// }

// export const ProjectTypeInitialsForUpdate={
//     AccountProjectTypeId:0,
//     ProjectType:"",
//     IsDisabled:false
// }

